module.exports = __webpack_public_path__ + "img/2018-09-2.0cdab27d.jpeg";